import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';

export const FLEET_ROUTES: Routes = [
  {
    path: 'fleet',
    loadComponent: () => import('./dashboard/fleet-dashboard.component').then(m => m.FleetDashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/drivers',
    loadComponent: () => import('./drivers-list/drivers-list.component').then(m => m.DriversListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/vehicles',
    loadComponent: () => import('./vehicles-list/vehicles-list.component').then(m => m.VehiclesListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/drivers/new',
    loadComponent: () => import('./create-driver/create-driver.component').then(m => m.CreateDriverComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/vehicles/new',
    loadComponent: () => import('./create-vehicle/create-vehicle.component').then(m => m.CreateVehicleComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/drivers/:id',
    loadComponent: () => import('./driver-view/driver-view.component').then(m => m.DriverViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/vehicles/:id',
    loadComponent: () => import('./vehicle-view/vehicle-view.component').then(m => m.VehicleViewComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fleet/post-availability',
    loadComponent: () => import('./post-availability/post-availability.component').then(m => m.PostAvailabilityComponent),
    canActivate: [authGuard]
  }
];
